'use client';

import { create } from 'zustand';

import type { MiniPdpDrawerOptions, MiniPdpDrawerState } from '../types';

export const useMiniPdpDrawer = create<MiniPdpDrawerState>(set => ({
    isOpen: false,
    productId: null,
    open: (options?: MiniPdpDrawerOptions) => {
        set({
            isOpen: true,
            productId: options?.productId ?? null,
        });
    },
    close: () => set({ isOpen: false, productId: null }),
}));
